<div
    class="forecast-container"
    [ngClass]="layout"
    *ngIf="showContent"
    [pTooltip]="forecastTooltip"
    tooltipStyleClass="wide-tooltip"
    tooltipPosition="bottom"
    [class.copyable]="canCopy"
    [attr.role]="canCopy ? 'button' : null"
    [attr.tabindex]="canCopy ? 0 : null"
    [attr.title]="canCopy ? 'Copy forecast breakdown to clipboard (Google Sheets)' : null"
    (click)="copyForecastToClipboard()"
    (keydown.Enter)="copyForecastToClipboard()"
    (keydown.Space)="$event.preventDefault(); copyForecastToClipboard()"
>
    <!-- FORECAST (PROPHET) -->
    <ng-container *ngIf="showForecast && forecast?.outcome">
        <!-- Card Layout (Vertical) -->
        <ng-container *ngIf="layout === 'card'">
            <div class="forecast-row main">
                <span class="forecast-val" title="Predicted Jobs"><i class="pi pi-briefcase"></i> {{ (forecast?.outcome?.expected_bookings || 0) | number:'1.0-0' }}</span>
                <span *ngIf="isHistorical" class="historical-badge" title="This is a past forecast — compare with actuals in the tooltip">Historical</span>
            </div>
        </ng-container>

        <!-- Strip Layout (Horizontal) -->
        <ng-container *ngIf="layout === 'strip'">
            <span class="forecast-label">{{ isHistorical ? 'Past Forecast' : 'Forecast' }}</span>
            <div class="forecast-metrics">
                <span title="Predicted Jobs"><i class="pi pi-briefcase"></i> {{ (forecast?.outcome?.expected_bookings ||
                    0) | number:'1.0-0' }}</span>
            </div>
        </ng-container>

        <!-- Pricing Tier Badge (Shared) -->
        <div
            class="forecast-tier"
            *ngIf="forecast?.discount?.tier as tier"
        >
            <span
                class="tier-badge"
                [class.tier-tag]="layout === 'strip'"
                [style.background]="tier.color || '#3b82f6'"
                [title]="tier.name + ': ' + (tier.percent > 0 ? '+' : '') + tier.percent + '%'"
            >{{ tier.name }}<span class="tier-pct"> {{ tier.percent > 0 ? '+' : '' }}{{ tier.percent }}%</span></span>
        </div>
    </ng-container>

    <!-- Copy affordance: the sr-only instruction appends to the strip
         box's accessible name INSTEAD of an aria-label, so the displayed
         values stay readable to screen readers (CodeRabbit Major — an
         aria-label would MASK the values). -->
    <span class="p-sr-only" *ngIf="layout === 'strip' && canCopy">Copy forecast breakdown to clipboard</span>
</div>

<ng-template #forecastTooltip>
    <div class="forecast-tooltip-content">
        <div
            class="tooltip-header"
            *ngIf="showForecast"
        >{{ isHistorical ? 'Historical Forecast vs Actual' : 'Forecast vs Actual' }}</div>

        <ng-container *ngIf="showForecast && forecast?.outcome as outcome">
            <div class="tooltip-row">
                <strong>Jobs (Moving):</strong>
                <span>{{ (outcome.expected_bookings || 0) | number:'1.0-0' }} predicted · {{ actualJobs }} booked</span>
            </div>
            <div class="tooltip-row" *ngIf="(outcome.expected_trucks || 0) > 0">
                <strong>Trucks:</strong>
                <span>{{ (outcome.expected_trucks || 0) | number:'1.0-0' }} predicted · {{ actualTrucksUsed }} booked
                    · {{ trucksAvailable }} available</span>
            </div>
            <div class="tooltip-row" *ngIf="(outcome.expected_crew || 0) > 0">
                <strong>Crew:</strong>
                <span>{{ (outcome.expected_crew || 0) | number:'1.0-0' }} predicted · {{ actualCrewUsed }} booked
                    · {{ crewAvailable }} available</span>
            </div>
            <div
                class="tooltip-divider"
                *ngIf="forecast?.discount"
            ></div>
            <ng-container *ngIf="forecast?.discount as discount">
                <div class="tooltip-row" *ngIf="discount.tier as tier">
                    <strong>Pricing Tier:</strong>
                    <span>
                        <span
                            class="tier-dot"
                            [style.background]="tier.color || '#3b82f6'"
                        ></span>
                        {{ tier.name }}
                        ({{ tier.percent > 0 ? '+' : '' }}{{ tier.percent }}%)
                    </span>
                </div>
                <div class="tooltip-row" *ngIf="discount.gateReason">
                    <strong>Gated:</strong>
                    <span>{{ discount.gateReason }}</span>
                </div>
                <div class="tooltip-row" *ngIf="discount.recommendation as rec">
                    <small>{{ rec }}</small>
                </div>
            </ng-container>
            <div class="tooltip-divider"></div>
            <div class="tooltip-row model-meta" *ngIf="forecast?.model_type">
                <span class="meta-label">Model</span>
                <span
                    [class.positive]="forecast.model_type === 'location'"
                    [pTooltip]="forecast.model_type === 'location' ? 'Trained on this location\'s own history' : 'No location-specific history — using the general franchise model'"
                >{{ forecast.model_type === 'location' ? 'Location-specific' : 'General' }}</span>
            </div>
            <div class="tooltip-row model-meta" *ngIf="prophetMetrics?.lastRun">
                <span class="meta-label">Last trained</span>
                <span>{{ prophetMetrics.lastRun | date:'MMM d, y h:mm a' }}</span>
            </div>
            <div class="tooltip-row model-meta" *ngIf="confidence !== null">
                <span class="meta-label">Confidence</span>
                <span
                    [class.positive]="confidence >= 0.7"
                    [class.negative]="confidence < 0.4"
                    pTooltip="How sure the model is about this day's forecast"
                >{{ confidence | percent:'1.0-0' }}</span>
            </div>
            <div class="tooltip-note">
                Forecast is a Prophet ML model retrained daily on historical booking patterns.
                These are daily averages &mdash; if your business is growing year-over-year, the model
                may predict lower than you actually book until it catches up.
            </div>
        </ng-container>

    </div>
</ng-template>